require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 293
// module chunks = 0